export default function Audio(audio, callback) {
  return {
    play: function() {
      try {
        if (!audio.paused) {
          audio.currentTime = 0
        }
        audio.play()
      } catch (e) {
        /* ignore */
      }
    },
    stop: function() {
      try {
        audio.currentTime = 0
      } catch (e) {
        /* ignore */
      }
    },
  }
}
